var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxRadioGroup',{attrs:{"items":[{ id: 1 }],"valueExpr":"id","value":_vm.setValue == 'Y' ? 1 : null,"onValueChanged":_vm.radioValueChange,"disabled":_vm.disabled,"elementAttr":{ class: 'gc-field-radio-wrapper' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }